import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ChatProvider } from '../contexts/ChatContext';
import { FloatingChatDock } from './chat/FloatingChatDock';
import { COMMUNITY_CHAT_ENABLED } from '../config/features';

/**
 * One ChatProvider for the whole signed-in session + floating dock overlay.
 * No-ops when community chat is disabled.
 */
export const AuthenticatedChatLayer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (!COMMUNITY_CHAT_ENABLED || loading || !isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <ChatProvider>
      {children}
      <FloatingChatDock />
    </ChatProvider>
  );
};
